import { ReactNode } from 'react';

export function FormFieldWrapper({ children }: { children: ReactNode }) {
  return <div className="flex flex-col gap-2 w-1/2">{children}</div>;
}
